module.exports = __webpack_public_path__ + "static/media/bigpic-design.410eb918.jpg";